import { useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Copy, Check, Pencil } from "lucide-react";

export const VinChip = ({ veiculo, onSaved }) => {
  const [edit, setEdit] = useState(false);
  const [val, setVal] = useState(veiculo?.vin || "");
  const [copiado, setCopiado] = useState(false);
  if (!veiculo?.id) return null;

  const copiar = async () => {
    try { await navigator.clipboard.writeText(veiculo.vin); } catch { /* sem acesso à área de transferência */ }
    setCopiado(true); setTimeout(() => setCopiado(false), 1500);
  };
  const guardar = async () => {
    const vin = val.toUpperCase().replace(/\s/g, "").slice(0, 17);
    setEdit(false);
    if (vin === (veiculo.vin || "")) return;
    try {
      const { data } = await api.put(`/veiculos/${veiculo.id}`, { vin });
      onSaved(data); toast.success("VIN gravado.");
    } catch (err) { toast.error(apiError(err)); }
  };

  if (edit) {
    return (
      <input autoFocus value={val} onChange={(e) => setVal(e.target.value.toUpperCase().replace(/\s/g, "").slice(0, 17))}
        onBlur={guardar} onKeyDown={(e) => { if (e.key === "Enter") e.currentTarget.blur(); if (e.key === "Escape") { setVal(veiculo.vin || ""); setEdit(false); } }}
        placeholder="VIN / Nº chassi" className="h-7 w-48 font-mono text-xs border border-slate-300 rounded px-2 bg-white" data-testid="pedido-vin-input" />
    );
  }
  if (!veiculo.vin) {
    return <button onClick={() => setEdit(true)} className="text-xs text-blue-600 hover:underline" data-testid="pedido-vin-adicionar">+ VIN</button>;
  }
  return (
    <span className="inline-flex items-center gap-1 rounded border border-slate-300 bg-white pl-2 pr-1 h-7" data-testid="pedido-vin">
      <span className="text-[9px] font-semibold text-slate-400">VIN</span>
      <span className="font-mono text-xs text-slate-800 select-all tracking-wide" data-testid="pedido-vin-valor">{veiculo.vin}</span>
      <button onClick={copiar} title="Copiar VIN" className="p-1 rounded hover:bg-slate-100 text-slate-500" data-testid="pedido-vin-copiar">
        {copiado ? <Check size={13} className="text-emerald-600" /> : <Copy size={13} />}
      </button>
      <button onClick={() => { setVal(veiculo.vin); setEdit(true); }} title="Corrigir VIN" className="p-1 rounded hover:bg-slate-100 text-slate-400" data-testid="pedido-vin-editar"><Pencil size={11} /></button>
    </span>
  );
};
